import useAxiosCall from './useAxiosCall';
import { useSidebarPermission } from '../Context/SidebarPermissionContext';
import { useDomain } from '../Context/DomainContext';
import { decryptData, encryptData } from '../Utilities/CryptoUtility';
const usePermissions = () => {
    const { makeApiCall } = useAxiosCall();
    const { setPermissions } = useSidebarPermission();
    const { domain: contextDomain } = useDomain();

    const handleApiCallSuccess = (data) => {
        let decryptedData = decryptData(data.data)
        if(decryptedData.permissions){
            setPermissions(decryptedData.permissions);
        } else {
            setPermissions([])
        }
    };

    const handleApiCallError = (errorMessage) => {
        console.error('Error fetching permissions:', errorMessage);
        setPermissions([]);
    };

    const fetchPermissions = async (domainOverride) => {
        try {
            const domain = domainOverride != null ? String(domainOverride) : contextDomain;
            if (!domain) {
                console.warn('fetchPermissions: domain not available, skipping');
                return;
            }
            const requestData = {
                data: encryptData(JSON.stringify(
                    {
                        domain
                    }
                ))
            };

            await makeApiCall({
                requestData,
                url: 'getPermissions',
                requestType: 'POST',
                onSuccess: handleApiCallSuccess,
                onError: handleApiCallError,
            });

        } catch (error) {
            console.error('Error fetching permissions:', error);;
        }
    };

    return { fetchPermissions };
};

export default usePermissions;
